var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _rect2, _rect3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _g, _circle2, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 190,
    viewBox: "0 0 209 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.91 60.6604V15.647H205.483V60.6604H134.91Z",
    fill: "#FF9201"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.485 60.6602L176.009 37.8326C172.407 35.356 167.638 35.343 164.022 37.7973C153.893 44.6729 134.912 60.6602 134.912 60.6602H205.485Z",
    fill: "#FFA500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.176 37.1362H164.97L134.91 15.6543L134.911 60.6603C134.911 60.6603 153.893 44.6731 164.02 37.7975C164.392 37.5453 164.783 37.3362 165.176 37.1362Z",
    fill: "#F2D773"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.425 37.1362H174.807C175.216 37.3454 175.621 37.5675 176.006 37.8328L205.483 60.6604V15.6543L175.425 37.1362Z",
    fill: "#F2D773"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.483 15.6543L176.007 38.4819C172.405 40.9584 167.636 40.9715 164.02 38.5171C153.892 31.6416 134.91 15.6543 134.91 15.6543H205.483Z",
    fill: "#FFF6DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.14 74.5561L123.147 21.7738C116.406 15.1822 105.55 15.1822 98.8092 21.7738L44.8164 74.5561V158.956H177.14V74.5561Z",
    fill: "#FF9201"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.6035,
    y: 35.7812,
    width: 94.75,
    height: 123.175,
    rx: 4,
    fill: "#FFF6DC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.916 68.3311C84.0582 68.3311 87.416 64.9732 87.416 60.8311C87.416 56.6889 84.0582 53.3311 79.916 53.3311C75.7739 53.3311 72.416 56.6889 72.416 60.8311C72.416 64.9732 75.7739 68.3311 79.916 68.3311ZM79.916 72.8311C86.5434 72.8311 91.916 67.4585 91.916 60.8311C91.916 54.2036 86.5434 48.8311 79.916 48.8311C73.2886 48.8311 67.916 54.2036 67.916 60.8311C67.916 67.4585 73.2886 72.8311 79.916 72.8311Z",
    fill: "#735B46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95.916,
    y: 53.8311,
    width: 36,
    height: 6,
    rx: 0.5,
    fill: "#735B46"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 95.916,
    y: 62.8311,
    width: 16,
    height: 5,
    rx: 0.5,
    fill: "#735B46"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M177.14 158.956L121.873 116.155C115.119 111.511 106.178 111.486 99.3973 116.088C80.4065 128.98 44.8164 158.956 44.8164 158.956H177.14Z",
    fill: "#FFDC81"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.563 114.848H101.176L44.8164 75.6416V158.956C44.8164 158.956 80.4065 128.98 99.3949 116.088C100.093 115.615 100.826 115.223 101.563 114.848Z",
    fill: "#FFCA00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.78 114.848H119.621C120.388 115.241 121.148 115.657 121.871 116.155L177.14 158.956V75.6416L120.78 114.848Z",
    fill: "#FFB800"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44531 174.361V129.347H74.0177V174.361H3.44531Z",
    fill: "#FF9201"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0197 174.36L44.5439 151.533C40.9421 149.056 36.1733 149.043 32.5571 151.498C22.4286 158.373 3.44727 174.36 3.44727 174.36H74.0197Z",
    fill: "#FFA500"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7116 150.836H33.5051L3.44531 129.354L3.44647 174.361C3.44647 174.361 22.4278 158.373 32.555 151.498C32.9275 151.245 33.3182 151.036 33.7116 150.836Z",
    fill: "#F2D773"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.96 150.836H43.3418C43.7509 151.046 44.156 151.268 44.5415 151.533L74.0186 174.361V129.354L43.96 150.836Z",
    fill: "#F2D773"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0177 129.354L44.542 152.182C40.9402 154.659 36.1713 154.672 32.5551 152.217C22.4267 145.342 3.44531 129.354 3.44531 129.354H74.0177Z",
    fill: "#FFF6DC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 172.568,
    cy: 144.743,
    r: 28.425,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.674 136.104C179.674 140.304 176.265 143.708 172.06 143.708C167.855 143.708 164.447 140.304 164.447 136.104C164.447 131.905 167.855 128.5 172.06 128.5C176.265 128.5 179.674 131.905 179.674 136.104Z",
    fill: "#735B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.78 160.944C186.78 160.944 177.202 161.039 171.045 160.944C166.074 160.868 158.355 160.944 158.355 160.944C158.355 160.944 160.386 145.736 172.568 145.736C184.75 145.736 186.78 160.944 186.78 160.944Z",
    fill: "#735B46"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.887,
    cy: 123.425,
    r: 11.8438,
    fill: "#735B46"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.886 117.898C194.268 117.898 194.577 118.207 194.577 118.589V122.734H198.723C199.104 122.734 199.414 123.043 199.414 123.425C199.414 123.807 199.104 124.116 198.723 124.116H194.577V128.261C194.577 128.643 194.268 128.952 193.886 128.952C193.505 128.952 193.196 128.643 193.196 128.261V124.116H189.05C188.669 124.116 188.359 123.807 188.359 123.425C188.359 123.043 188.669 122.734 189.05 122.734H193.196V118.589C193.196 118.207 193.505 117.898 193.886 117.898Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.482d57890c3da2c38f3eb2503283ba3d.svg";
export { ForwardRef as ReactComponent };